<template>
  <div>
    <v-row>
      <v-col class="text-left">
        <h2 style="padding-left: 15px">供應商: {{ this.merchantName }}</h2>
      </v-col>
      <v-col class="text-right">
        <v-icon @click="handleOpenTagDialog(false)">mdi-plus</v-icon>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="merchantAnnouncementLists"
      :header-props="{ sortIcon: null }"
      :page="page.pageNo"
      :items-per-page="page.pageSize"
      :server-items-length="totalCount"
      @update:options="update"
    >
      <template v-slot:item="row">
        <tr>
          <td>{{ row.item.content }}</td>
          <td>{{ row.item.startTime | dateTime }}</td>
          <td>{{ row.item.endTime | dateTime }}</td>
          <td>
            <button @click="handleOpenTagDialog(true, row.item)">
              <v-icon>mdi-lead-pencil</v-icon>
            </button>
          </td>
          <td>
            <button @click.stop="handleDelete(row.item)">
              <v-icon>mdi-window-close</v-icon>
            </button>
          </td>
        </tr>
      </template>
    </v-data-table>
    <Dialog
      :width="500"
      :title="isEdit ? '修改公告' : '新增公告'"
      :key="dialogInfo.key"
      :isVisible="isCreateEditDialog"
      @ok="handleSubmit"
      @cancel="handleCloseDialog"
    >
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="3" align-self="center">開始時間</v-col>
            <v-col cols="4">
              <DateRange
                @input="dialogInfo.startDate = $event"
                :value="dialogInfo.startDate | date"
                :rules="startDateRule"
              />
            </v-col>
            <v-col cols="5">
              <time-picker v-model="dialogInfo.startTime" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" align-self="center">結束時間</v-col>
            <v-col cols="4">
              <DateRange
                @input="dialogInfo.endDate = $event"
                :value="dialogInfo.endDate | date"
                :rules="endDateRule"
              />
            </v-col>
            <v-col cols="5">
              <time-picker v-model="dialogInfo.endTime" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" align-self="center">公告內容</v-col>
            <v-col cols="9">
              <v-textarea v-model="dialogInfo.content" :rules="contentRule"
            /></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </Dialog>
  </div>
</template>

<script>
import DateRange from '@/components/DateRange.vue';
import TimePicker from '@/components/TimePicker.vue';
import ruleMixin from '@/minix/ruleMixin';
import Dialog from '@/components/Dialog.vue';
import api from '@/api';
import moment from 'moment';
import Swal from 'sweetalert2';

const defaultPage = {
  pageSize: 5,
  pageNo: 1,
};

export default {
  mixins: [ruleMixin],
  components: {
    DateRange,
    TimePicker,
    Dialog,
  },
  data() {
    return {
      valid: true,
      isCreateEditDialog: false,
      isEdit: false,
      dialogInfo: {
        merchantAnnouncementId: '',
        content: '',
        startDate: '',
        startTime: '00:00',
        endDate: '',
        endTime: '00:00',
        key: 0,
      },
      headers: [
        { text: '公告內容', value: 'content' },
        { text: '開始時間', value: 'startTime' },
        { text: '結束時間', value: 'endTime' },
        { text: '修改', value: 'edit' },
        { text: '刪除', value: 'delete' },
      ],
      merchantName: '',
      merchantAnnouncementLists: [],
      totalCount: 0,
      page: {
        ...defaultPage,
      },
      contentRule: this.requiredRule('公告內容'),
      startDateRule: this.requiredRule('開始時間'),
      endDateRule: this.requiredRule('結束時間'),
    };
  },
  computed: {
    merchantId() {
      return this.$route.params.id;
    },
  },
  filters: {
    dateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    },
  },
  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      const params = {
        ...this.removeEmptyValue(this.page),
        pageSize:
          this.page.pageSize === -1 ? this.totalCount : this.page.pageSize,
      };
      const {
        data: { totalCount = 0, merchantName = '', announcements = [] },
      } = (await api.merchantannouncement.list(this.merchantId, params)) || {};
      this.totalCount = totalCount;
      this.merchantName = merchantName;
      this.merchantAnnouncementLists = announcements;
    },
    removeEmptyValue(object) {
      const newObj = {};
      Object.keys(object).forEach((key) => {
        const v = object[key];
        const isNullOrEmpty = v === '' || v === undefined || v === null;
        if (!isNullOrEmpty) {
          newObj[key] = object[key];
        }
      });
      return newObj;
    },
    update(options) {
      this.page = {
        pageSize: options.itemsPerPage,
        pageNo: options.page,
      };
      this.getList();
    },
    handleCloseDialog() {
      if (this.isCreateEditDialog) {
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }
      this.isCreateEditDialog = false;
    },
    handleOpenTagDialog(isEdit, item) {
      this.isEdit = isEdit;
      if (!this.isEdit) {
        this.dialogInfo = {
          startDate: '',
          startTime: '00:00',
          endDate: '',
          endTime: '00:00',
          content: '',
          key: Date.now(),
        };
      } else {
        this.dialogInfo = {
          ...item,
          key: Date.now(),
          startDate: moment(item.startTime).format('YYYY-MM-DD'),
          startTime: moment(item.startTime).format('HH:mm'),
          endDate: moment(item.endTime).format('YYYY-MM-DD'),
          endTime: moment(item.endTime).format('HH:mm'),
        };
      }
      this.isCreateEditDialog = true;
    },
    async handleSubmit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const parameter = {
        ...this.dialogInfo,
        startTime: `${this.dialogInfo.startDate}T${this.dialogInfo.startTime}:00`,
        endTime: `${this.dialogInfo.endDate}T${this.dialogInfo.endTime}:00`,
      };
      if (this.isEdit) {
        await api.merchantannouncement.edit(
          this.merchantId,
          this.dialogInfo.merchantAnnouncementId,
          parameter,
        );
      } else {
        await api.merchantannouncement.add(this.merchantId, parameter);
      }
      await this.getList();
      this.handleCloseDialog();
    },
    async handleDelete(item) {
      const { merchantAnnouncementId } = item;
      await Swal.fire({
        title: '確定要刪除公告嗎?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { status } = await api.merchantannouncement.delete(
            this.merchantId,
            merchantAnnouncementId,
          );
          if (status === 1) {
            await Swal.fire({ icon: 'success', title: '刪除成功' });
            await this.getList();
          } else {
            await Swal.fire({
              icon: 'warning',
              title: '刪除失敗，請聯繫系統管理員。',
            });
          }
        }
      });
    },
  },
};
</script>
